module.exports = __webpack_public_path__ + "img/p3.54033fdf.png";